<template>
  <div class="hello">
    <remindListTop @event3="change3($event)" @transformVal="getVal" @exportMethod="exportHandle" :exportStatus="exportLoading" @fatherMethod="getremindlist"></remindListTop>
    <!-- <s65 v-if="isHandled==0"></s65>
      <s65Processed v-if="isHandled==1"></s65Processed> -->
    <div class="contract">
      <div class="main-con">
        <div class="crumbs">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>通知</el-breadcrumb-item>
            <el-breadcrumb-item>待办事项</el-breadcrumb-item>
            <el-breadcrumb-item>65周岁提醒</el-breadcrumb-item>
            <el-breadcrumb-item>
              <span v-show="isHandled =='0'">待处理</span>
              <span v-show="isHandled =='1'">已处理</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="idCardTable">
          <el-table :data="tableData" :max-height="tableHeight-180" style="width: 99%" stripe v-loading="listLoading">
            <!-- <el-table-column align="center" type="selection" width="50px"></el-table-column> -->
            <el-table-column align="center" label="序号" prop="num" width="50"></el-table-column>
            <el-table-column align="center" label="项目名称" prop="StrObjName" fit min-width="100px" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="档案号" prop="StrFileNo" min-width="120px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="姓名" prop="StrEmpName" min-width="70px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="身份证号码" prop="StrIdCard" min-width="160px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="性别" prop="sex" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="出生年月" prop="birth" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="年龄" prop="age" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="合同（协议）类型" prop="StrContractType" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="65周岁倒计时" min-width="140px" prop="dueDate" fit :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-if="scope.row.dueDate<0" style="color: #FF4362;">{{"已过期" + jugdeDate(-scope.row.dueDate)}}</span>
                <span v-else style="color: #F78500;">{{"剩余" + jugdeDate(scope.row.dueDate)}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" fixed="right" label="操作" min-width="180px">
              <template slot-scope="scope">
                <el-button type="warning" size="small" plain @click="addHandle(scope.row)" v-if="isHandled =='0'">确认处理</el-button>
                <el-button type="danger" size="small" plain v-show="(isHandled =='1'&& scope.row.StrWorkState=='在职')||(isHandled =='0'&& scope.row.StrWorkState=='在职')" @click="quit(scope.row)">离职</el-button>
                <el-button type="warning" size="small" plain @click="revokeHandle(scope.row)" v-if="isHandled == '1'">撤销处理</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" v-show="totalcount>0">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage3" :page-size="pagecount" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="this.totalcount"></el-pagination>
          </div>
        </div>
      </div>
      <el-dialog title="确认处理" :visible.sync="dialogVisible1" width="30%">
        <span>若您已在线下完成处理，无需再进行其他线上操作，请点击确认</span>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible1 = false">取消</button>
          <button class="search" @click="changeSolve" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
      <el-dialog title="撤销处理" :visible.sync="dialogVisible4" width="30%">
        <span>点击“撤销处理”后，本条待办事项将重新在“待办事项”列表中</span>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible4 = false">取消</button>
          <button class="search" @click="revokeSubmit" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
      <el-dialog title="离职" :visible.sync="dialogVisible3" width="410px">
        <span>您正在给"{{this.emprow.StrEmpName}}""{{this.emprow.StrIdCard}}"办理离职手续，请可核对无误后再确认</span>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible3 = false">取消</button>
          <button class="search" @click="confirmQuit()" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "./../../common";
  import remindListTop from "./components/remindListTop.vue";
  // import s65 from "./s65";
  // import s65Processed from "./s65Processed";
  export default {
    components: {
      remindListTop
    },
    data() {
      return {
        tableHeight: 0,
        listLoading: false,
        isHandled: 0,
        emprow: "",
        totalcount: null,
        currpage: 1,
        status: 0,
        select: "",
        value1: "",
        dialogVisible1: false,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        currentPage3: 1,
        remindQuery: {
          tableid: "XZ_emp_UserBase",
          pagecount: 10,
          currpage: 1,
          content: 'oldage',
          strstatus: "0",
          strempname: ""
        },
        exportQuery: {
          tableid: "XZ_emp_UserBase",
          pagecount: 100000,
          currpage: 1,
          content: 'oldage',
          strstatus: "0",
          strempname: ""
        },
        pagecount: 10,
        tableData: [],
        //确认处理参数-档案号
        strfileno: '',
        //导出按钮加载状态
        exportLoading: false,
        info: {}
      }
    },
    mounted() {
      this.calHeight();
      this.getremindlist();
    },
    methods: {
      //一键导出
      exportHandle() {
        this.exportLoading = true
        xz.outputQueryEmpCust(this.exportQuery).then(res => {
          // console.log('process', res)
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/xlsx`
            })
            let aLink = document.createElement("a")
            aLink.download = '导出列表.xlsx'; //这里写保存时的文件名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.expLoading = false;
          } else {
            this.$message({
              message: "导出错误，请稍后再试",
              type: "error"
            });
          }
          this.exportLoading = false
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      jugdeDate(date) {
        if (date <= 30) {
          return date + '天'
        } else if (date > 30 && date < 360) {
          let d = date % 30;
          let m = Math.floor(date / 30);
          console.log('y', d, m);
          if (d == 0) {
            return m + '个月'
          } else {
            return m + '个月' + d + '天'
          }
        } else if (date > 360 && date < 1080) {
          return '1年以上'
        } else {
          return '1年以上'
        }
      },
      change3(data) {
        this.isHandled = data;
        this.remindQuery.strstatus = data
        this.remindQuery.currpage = 1
      },
      getVal(data) {
        // console.log('名称',data)
        this.remindQuery.strempname = data
      },
      handleCurrentChange(val) {
        this.currpage = `${val}`;
        this.remindQuery.currpage = `${val}`;
        this.getremindlist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.remindQuery.pagecount = `${val}`;
        this.pagecount = parseInt(val);
        this.getremindlist();
      },
      //处理
      addHandle(row) {
        this.info = row;
        this.dialogVisible1 = true;
        this.strfileno = row.StrFileNo
      },
      //确认处理
      changeSolve() {
        let d = {
          status: 1, //1 处理，0 退回
          content: 'cont',
          StrExcelPath: this.info.StrExcelPath,
          IntExcelLine: this.info.IntExcelLine,
        }
        xz.updatecustBystrfileNo(d, localStorage.loginRoletype).then(res => {
          //  console.log('处理',res)
          if (res.status == 'ok') {
            this.$message({
              message: "处理成功！",
              type: "success"
            });
            this.getremindlist();
            //侧边栏数量重新查询
            this.$store.commit("getLeftNum");
          } else {
            this.$message.error(res.msg);
          }
          this.dialogVisible1 = false;
        });
      },
      //确认撤销
      revokeHandle(row) {
        this.info = row;
        this.dialogVisible4 = true;
        this.strfileno = row.StrFileNo
      },
      //确认撤销处理
      revokeSubmit() {
        let d = {
          status: 0, //1 处理，0 退回
          content: 'oldage',
          StrExcelPath: this.info.StrExcelPath,
          IntExcelLine: this.info.IntExcelLine,
        }
        xz.updatecustBystrfileNo(d, localStorage.loginRoletype).then(res => {
          //  console.log('处理',res)
          if (res.status == 'ok') {
            this.$message({
              message: "撤销成功！",
              type: "success"
            });
            this.getremindlist();
            //侧边栏数量重新查询
            this.$store.commit("getLeftNum");
          } else {
            this.$message.error(res.msg);
          }
          this.dialogVisible4 = false;
        });
      },
      //离职
      quit(row) {
        this.emprow = row;
        this.dialogVisible3 = true;
      },
      //确认离职
      confirmQuit() {
        const data = {
          tableid: "XZ_emp_UserBase",
          excelpath: this.emprow.StrExcelPath,
          execlline: this.emprow.IntExcelLine,
          cluname: "StrWorkState",
          cluvalue: "离职"
        };
        xz.editEmployeeInfo(data).then(res => {
          if (res == true) {
            this.$message({
              message: "信息修改成功！",
              type: "success"
            });
          } else {
            this.$message.error("信息修改失败！");
          }
          this.dialogVisible3 = false;
          this.getremindlist();
          this.emprow = "";
          this.value1 = "";
        });
      },
      //获取待办事项列表
      getremindlist() {
        console.log('待办事项列表', this.remindQuery)
        // this.tableData = []
        this.listLoading = true
        xz.getremindlist(this.remindQuery, localStorage.loginRoletype).then(res => {
          console.log('待办事项列表', res)
          if (res.data && res.data.length > 0) {
            let i = 1 + (this.currpage - 1) * 10;
            res.data.forEach(l => {
              this.getBirth(l.StrIdCard)
              var arr = this.getBirth(l.StrIdCard)
              var age = arr[0];
              var birth = arr[1];
              var nowbirth = arr[2];
              var sex = arr[3];
              // this.calculateDays(nowbirth)
              var dueDate = this.calculateDays(nowbirth)
              l['dueDate'] = dueDate;
              l['age'] = age;
              l['birth'] = birth;
              l['sex'] = sex;
              l['num'] = i++;
            });
            this.tableData = res.data;
            this.totalcount = parseInt(res.count);
          } else {
            this.tableData = []
            this.totalcount = 0
          }
          this.listLoading = false
        })
      },
      //计算生日 年龄 性别
      getBirth(iden) {
        let age, day;
        let sexnum = null;
        let sex = null;
        let myDate = new Date();
        let month = myDate.getMonth() + 1;
        day = myDate.getDate();
        sexnum = iden.substring(16, 17);
        // console.log('iden',day)
        if (sexnum % 2 === 0) {
          sex = "女";
        } else {
          sex = "男";
        }
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;
        if (
          iden.substring(10, 12) < month ||
          (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
        )
          age++;
        var birth = iden.substring(6, 10) + "-" + iden.substring(10, 12) + "-" + iden.substring(12, 14);
        let year = Number(iden.substring(6, 10)) + 65;
        var nowbirth = year + "-" + iden.substring(10, 12) + "-" + iden.substring(12, 14);
        // console.log(age,birth)
        var arr = [];
        arr.push(age, birth, nowbirth, sex);
        return (arr)
      },
      //计算剩余天数
      calculateDays(sDate2) {
        let aDate, oDate1, oDate2, iDays;
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let sDate1 = year + "-" + month + "-" + day;
        aDate = sDate1.split("-");
        oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]); //转换为yyyy-MM-dd格式
        aDate = sDate2.split("-");
        oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]);
        iDays = (oDate2 - oDate1) / 1000 / 60 / 60 / 24; //把相差的毫秒数转换为天数
        if (iDays > 0) {
          iDays = Math.ceil(iDays);
          return (iDays)
        } else {
          iDays = Math.floor(iDays);
          return (iDays)
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>